import { GO_BYSTADIUM_GET_A_QUOTE_ROUTE } from "@stadium/constants/external-routes";
import {
  KITS_DASHBOARD_ROUTE,
  CHOOSE_ESHOPS_TEMPLATE_URL,
  LOCKER_SAVED_DESIGNS_URL,
  MYSHOPS_URL,
  SENT_GIFTS_PURACHES_URL,
  STADIUM_LOCKER_DASHBOARD_URL,
  CAMPAIGNS_URL,
  SEND_ITEMS_ROUTE,
  P2P_LANDING_PAGE_URL,
  MERGED_WALLET_URL,
} from "@stadium/shared/src/constants/routes";
import { MY_WALLET } from "@stadium/constants/wallets";
import { HELP_CENTER_URL } from "@stadium/constants/routes";

export const MY_SHOPS_TEXT = "My Shops";
export const SENDER = "Sender";

const getSendingLinks = () => [
  {
    label: MY_SHOPS_TEXT,
    to: MYSHOPS_URL,
  },
  {
    label: "Kits & Send Items",
    to: KITS_DASHBOARD_ROUTE,
  },
  {
    label: "Peer-to-Peer Recognition Programs",
    to: P2P_LANDING_PAGE_URL,
  },
  {
    label: "Campaigns",
    to: CAMPAIGNS_URL,
  },
];

const QUICK_LINKS_LABEL = {
  shopTemplates: "Shop Templates",
  sendItems: "Send Items",
  myWallet: MY_WALLET,
  getAQuote: "Get a Quote",
  helpCenter: "Help Center",
  sentOrders: "Sent Orders",
};

const getQuickLinks = () => [
  {
    label: QUICK_LINKS_LABEL.shopTemplates,
    to: CHOOSE_ESHOPS_TEMPLATE_URL,
    order: 1,
  },
  {
    label: QUICK_LINKS_LABEL.sendItems,
    to: SEND_ITEMS_ROUTE,
    order: 5,
  },
  {
    label: QUICK_LINKS_LABEL.myWallet,
    to: MERGED_WALLET_URL,
    order: 2,
  },
  {
    label: QUICK_LINKS_LABEL.getAQuote,
    to: GO_BYSTADIUM_GET_A_QUOTE_ROUTE,
    order: 6,
  },
  {
    label: QUICK_LINKS_LABEL.helpCenter,
    to: HELP_CENTER_URL,
    order: 7,
    isExtLink: true,
  },
  {
    label: QUICK_LINKS_LABEL.sentOrders,
    to: SENT_GIFTS_PURACHES_URL,
    order: 4,
  },
];

const getSwagLinks = ({ fetchedUrls: { lockerShopFeUrl } }) => [
  {
    label: "My Swag",
    to: STADIUM_LOCKER_DASHBOARD_URL,
  },
  {
    label: "Purchase Swag",
    to: lockerShopFeUrl,
    isExtLink: true,
  },
  {
    label: "Saved Designs",
    to: LOCKER_SAVED_DESIGNS_URL,
  },
];

export const getSenderLinks = ({ fetchedUrls: { lockerShopFeUrl } }) => [
  {
    title: "SENDING",
    items: getSendingLinks(),
  },
  {
    title: "SWAG",
    items: getSwagLinks({ fetchedUrls: { lockerShopFeUrl } }),
  },
  {
    title: "QUICK LINKS",
    items: getQuickLinks(),
    applyDividerClass: true,
  },
];
